import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Rose as RoseComponent } from '@ow/charts/lib'
import { getApiVersion, http } from '@vt/apis/lib-ex'
import { cloneDeep } from 'lodash-es'
import NullData from './nullData'

const Rose = function ({ data, customDsl }) {
  const [itemData, setItemData] = useState([])
  const { appId } = useParams()

  useEffect(() => {
    let newDsl = data.dsl
    const _dsl = cloneDeep(customDsl)
    if (_dsl) {
      if (Object.keys(data.dsl).length !== 0) {
        _dsl.childQueries.push(data.dsl)
      }
      newDsl = _dsl
    }
    http()
      .post(`${getApiVersion()}/apps/${appId}/${data.fetch}`, { ...newDsl })
      .json()
      .then((res) => {
        setItemData(res)
      })
  }, [customDsl])

  return (
    <div className="h-full w-full">
      {itemData.length === 0 && <NullData />}
      {itemData.length !== 0 && (
        <RoseComponent
          id="rose"
          width="100%"
          height="100%"
          data={itemData}
          showLabel={false}
          radius={['20%', '90%']}
          legend={{
            orient: 'vertical',
            right: 10,
            top: 20,
            textStyle: {
              color: '#fff',
              fontSize: 10,
            },
            itemWidth: 6,
            itemHeight: 6,
            icon: 'circle',
            type: 'scroll',
          }}
          roseType="area"
          right={80}
        />
      )}
    </div>
  )
}

export default Rose
